import { Named } from './named';
import { IResourceContext, IValidationContext, IViolation } from './annotation';
import { Metamodel } from './model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { NamedCompositeValidator } from './named-composite-validator';
import { NamedValidations } from './named-validations';
import { IMetadataModeService } from '../../interfaces/IMetadataModeService';

@Metamodel.model({
    name: 'parameter',
    display: ['parameter', 'parameters'],
    referable: true,
    globalScope: true,
    constraints: {
        name: {
            required: true,
            validator: NamedCompositeValidator.CreateValidator([
                NamedValidations.KeyWordsValidator,
                NamedValidations.StartsWithNumberValidator])
        },
        defaultValue: {
            validator: Parameter.prototype.validateDefaultValue
        }
    }
})
export class Parameter extends Named {

    public static getMetadataModeService: (contextData: IResourceContext) => Promise<IMetadataModeService>;

    public get defaultValue(): string {
        return this._defaultValue;
    }

    public set defaultValue(value: string) {
        this._defaultValue = value;
    }

    private _defaultValue: string;

    constructor(name?: string, description?: string, id?: number, public _type?: string) {
        super(name, description, id);
    }

    protected async validateDefaultValue(parameter?: Parameter, defaultValue?: string, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> {
        const violations: IViolation[] = [];

        if (parameter && defaultValue) {
            const parameterType = parameter._type ? parameter._type.toLowerCase() : '';

            switch (parameterType) {
                case 'int':
                    if (!Number.isInteger(Number(defaultValue))) {
                        violations.push({
                            message: () => shellStringResources.Parameterization_ValidIntegerErrorMessage
                        });
                    }
                    break;

                case 'float':
                    if (isNaN(Number(defaultValue))) {
                        violations.push({
                            message: () => shellStringResources.Parameterization_ValidFloatErrorMessage
                        });
                    }
                    break;

                case 'bool':
                    if (String(defaultValue) !== 'true' && String(defaultValue) !== 'false') {
                        violations.push({
                            message: () => shellStringResources.Parameterization_ValidBooleanErrorMessage
                        });
                    }
                    break;

                case 'array':
                    try {
                        const defaultArray = JSON.parse(String(defaultValue));

                        if (!Array.isArray(defaultArray)) {
                            violations.push({
                                message: () => shellStringResources.Parameterization_ValidArrayErrorMessage
                            });
                        }
                    } catch (error) {
                        violations.push({
                            message: () => shellStringResources.Parameterization_ValidArrayErrorMessage
                        });
                    }
                    break;

                case 'securestring':
                    const metadataService = await Parameter.getMetadataModeService(context.contextData);

                    if (metadataService.isGitMode()) {
                        violations.push({
                            message: () => shellStringResources.Parameterization_SecureStringWarningInGit
                        });
                    }
                    break;

                default:
                    break;
            }
        }

        return violations.length <= 0 ? undefined : violations;
    }
}
